// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__AlNKc","loader--blur":"loader_loader--blur__+KUc1"};